import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useEffect, useState } from 'react'

import useHomepage from '../../hooks/useHomepage'
import UtmContent from '../../models/UtmContent'
import { AnalyticsService } from '../../services'
import { UrlService } from '../../services'
import ScrollAnimation from '../scroll-animation/Container'

const Action = () => {
  const {
    activeCityName,
    productOffering,
    showModal,
    launchConfirmationRequired,
    onNyLunchPage,
    onSfLunchPage,
    landingPageAlias,
    animationProps,
  } = useHomepage()
  const { t } = useTranslation()
  const [url, setUrl] = useState('')

  useEffect(() => {
    const position =
      landingPageAlias === '' ? `${productOffering}-secondary-restaurants` : `${landingPageAlias}-secondary-restaurants`
    const utmContent = new UtmContent({ position }).toString()
    setUrl(UrlService.signupUrl({ utmContent: utmContent, cityName: activeCityName }))
  }, [productOffering, onNyLunchPage, onSfLunchPage])

  const onClickHandler = (e: React.MouseEvent) => {
    if (launchConfirmationRequired) {
      e.preventDefault()

      return showModal({ name: 'get-access-form' })
    }

    AnalyticsService.trackEvent({
      action: 'Click',
      category: 'Homepage',
      label: 'Start Saving on Lunch Today - Top',
    })
  }

  return (
    <ScrollAnimation {...animationProps}>
      <a href={url} className="meals__action red-cta" onClick={onClickHandler}>
        {t(`Start saving on ${productOffering} today`)}
      </a>
    </ScrollAnimation>
  )
}

export default Action
